import { ReactNode } from "react";
import { AioNumber } from "../additional/aioNumber";
import styles from "../aic.module.css";
import { AitCellData } from "./functions/AitCellData";
import { getBaseId } from "./functions/getBaseId";
import { AitCellType, AitLocationBodyCell, UPDATE_TABLE_CELL } from "./functions/interface";
import { trGetCellFromLocation } from "./functions/trGetCellFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitCellIndentsProps {
  location: AitLocationBodyCell;
}

/**
 * Control to edit text indents for a row-header cell.
 *
 * @template T - Cell payload type
 * @param props - Component props
 * @param props.location - The body cell location
 */
export const AitCellIndents = <T,>({ location }: AitCellIndentsProps): ReactNode => {
  const { state, dispatch } = useTableContext<T>();
  const thisCell: AitCellData<T> | undefined = state?.processedTableData
    ? trGetCellFromLocation(state.processedTableData, location)
    : undefined;
  const id = getBaseId(location, state?.id);

  return !thisCell || location.cellType !== AitCellType.rowHeader ? null : (
    <div className={styles.aiwBodyRow}>
      <AioNumber
        id={`${id}-indents`}
        label="Text indents"
        value={
          thisCell.textIndents ??
          // istanbul ignore next
          0
        }
        setValue={
          !thisCell.readOnly && !location.isRepeat
            ? (ret) =>
                dispatch({ operation: UPDATE_TABLE_CELL, location, cellData: { textIndents: ret } })
            : undefined
        }
      />
    </div>
  );
};

AitCellIndents.displayName = "AitCellIndents";
